import type { Dict } from './index';

// Endonezce sözlük — Claude tarafından elle çevrildi (06.08.2026), makine
// çevirisi kullanılmadı. en.ts ile aynı yapıda olmalı (tip zorunlu kılar).
export const id: Dict = {
  signInMethods: {
    // D-871 — the linked Google accounts, and removing one.
    googleAccountUnknown: "Akun Google (alamat belum diketahui)",
    googleLinkedDate: "Ditautkan {date}",
    googleRemove: "Hapus",
    googleRemoveTitle: "Hapus akun Google ini?",
    googleRemoveBody: "Kamu akan mengonfirmasi nomor terdaftarmu terlebih dahulu. Setelah itu, akun Google ini tidak bisa lagi masuk ke nosubject.",
    googleRemoveConfirm: "Masukkan kode untuk menghapus {account}.",
    googleRemoved: "Akun Google dihapus.",
    googleLastMethod: "Ini satu-satunya cara masuk ke akun ini, jadi tidak bisa dihapus.",
    googleAddAnother: "Hubungkan akun Google lain",
    googleLinkedCount: "Akun Google terhubung: {count}",
    googleLinked: "Akun Google terhubung.",
    googleCodeSent: "Kode telah dikirim ke nomor terdaftarmu yang berakhiran {phone}.",
    googleChooseHint: "Akun Google yang kamu pilih akan dihubungkan untuk masuk ke akun nosubject ini.",
    googleStatusUnknown: "Status koneksi Google tidak dapat diperiksa. Silakan periksa lagi.",
    googleLinkIntro: "Verifikasi nomor telepon yang terdaftar pada akun ini sebelum menghubungkan Google.",
    googleLinkFailed: "Permintaan tidak dapat diselesaikan. Silakan coba lagi.",
    googleSendCode: "Kirim kode verifikasi",
    googleCodeLabel: "Kode verifikasi",
    googleStartAgain: "Mulai lagi",
    googleContinue: "Lanjutkan dengan Google",
    googleFailed: "Login dengan Google tidak dapat diselesaikan. Silakan coba lagi.",
    googleNotLinked: "Akun Google ini belum ditautkan ke akun nosubject.",
    googleUnavailable: "Login dengan Google belum tersedia.",
    title: "Metode masuk",
    intro: "Bagian ini sedang disiapkan. Opsi untuk mengelola metode masuk akan ditambahkan nanti.",
    identity: "Verifikasi identitas",
    identityInfo: "Verifikasi identitas merupakan proses yang terpisah dari masuk ke akun.",
  },
  safety: {
    title: 'Nomor keamanan',
    compare: 'Cocokkan nomor ini dengan {name}. Jika sama, tidak ada pihak lain di antara kalian yang bisa membaca pesan kalian.',
    explainInfo: 'Nomor ini dihitung dari kunci enkripsi semua perangkat kalian berdua saat ini dan sama di kedua ponsel. Jika salah satu dari kalian menambahkan perangkat, misalnya ponsel baru atau web, nomornya berubah; cocokkan lagi saat itu. Verifikasi hanya disimpan di perangkat ini.',
    qrLabel: 'Kode QR nomor keamanan',
    verified: 'Terverifikasi',
    notVerified: 'Belum diverifikasi',
    markVerified: 'Tandai terverifikasi',
    clearVerified: 'Hapus verifikasi',
    peerUnavailable: 'Enkripsi dengan orang ini belum aktif.',
    selfUnavailable: 'Kunci enkripsi perangkat ini belum siap.',
    loadFailed: 'Nomor keamanan tidak dapat dimuat.',
  },
  backup: {
    title: 'Cadangan obrolan',
    explainInfo: 'Riwayatmu ada di perangkat ini. Cadangan mengenkripsinya dengan kode pemulihanmu dan menyimpannya di server; kami tidak bisa membukanya.',
    create: 'Buat cadangan',
    refresh: 'Perbarui cadangan',
    codeTitle: 'Kode pemulihanmu',
    codeWarning: 'Simpan kode ini di tempat aman. Kalau hilang, riwayatmu tidak kembali, dan kami pun tidak bisa membukanya.',
    restoreTitle: 'Pulihkan riwayat',
    restorePlaceholder: 'Kode pemulihan',
    restore: 'Pulihkan',
    restored: '{count} pesan dipulihkan.',
    restoreFailed: 'Riwayat tidak bisa dibuka. Periksa kodenya.',
    failed: 'Cadangan gagal.',
  },
  common: {
    clear: "Hapus pencarian",
    infoHide: 'Sembunyikan penjelasan: {subject}',
    infoShow: 'Tampilkan penjelasan: {subject}',
    continue: 'Lanjutkan',
    cancel: 'Batal',
    close: 'Tutup',
    save: 'Simpan',
    done: 'Selesai',
    retry: 'Coba lagi',
    error: 'Kesalahan',
    back: 'Kembali',
    search: 'Cari…',
    loading: 'Memuat',
    remove: 'Hapus',
    offline: 'Server tidak bisa dihubungi. Periksa koneksimu.',
    sessionExpired: 'Sesimu berakhir. Masuk lagi.',
    tooManyRequests: 'Terlalu banyak permintaan. Tunggu sebentar dan coba lagi.',
  },
  time: {
    now: 'baru saja',
    minAgo: '{n} mnt lalu',
    hourAgo: '{n} j lalu',
    yesterday: 'kemarin',
    dayAgo: '{n} hari lalu',
    weekAgo: '{n} minggu lalu',
    weekAgoOne: '{n} minggu lalu',
    today: 'Hari ini',
    dayYesterday: 'Kemarin',
  },
  phone: {
    sendFailed: "Kode tidak dapat dikirim. Coba lagi.",
    subtitle: 'Masukkan nomor teleponmu',
    selectCountry: 'Negara / wilayah',
    countrySearch: 'Cari negara…',
    architectureLink: 'Arsitektur teknis dan peta jalan ↗',

  },
  otp: {
    verifyFailed: "Kode tidak dapat diverifikasi. Coba lagi.",
    invalidCode: "Kode tidak valid atau sudah kedaluwarsa.",
    rateLimited: "Terlalu banyak percobaan. Coba lagi nanti.",
    title: 'Masukkan kode',
    sentTo: 'Kami mengirim SMS ke {phone}',
    verify: 'Verifikasi',
    resend: 'Kirim ulang',

    tooManyAttempts: 'Terlalu banyak percobaan. Tunggu sebentar dan coba lagi.',

    resendSent: 'Kode baru telah dikirim.',
    resendFailed: 'Kode tidak bisa dikirim. Periksa koneksimu dan coba lagi.',
    resendWait: 'Bisa minta lagi dalam {n} dtk',
  },
  university: {
    title: 'Universitas mana?',
    subtitle: 'Cari untuk menemukan',
    placeholder: 'Harvard, Oxford…',
    skip: 'Lewati',
  },
  profession: {
    title: 'Apa pekerjaanmu?',
    subtitle: 'Cari profesimu',
    placeholder: 'Guru, developer, perawat…',
    skip: 'Lewati',
  },
  isco: {
    '0': 'Angkatan bersenjata',
    '1': 'Manajer',
    '2': 'Profesional',
    '3': 'Teknisi dan profesional tingkat menengah',
    '4': 'Tenaga tata usaha',
    '5': 'Tenaga usaha jasa dan penjualan',
    '6': 'Pekerja pertanian, kehutanan, dan perikanan',
    '7': 'Pekerja terampil dan tenaga kerajinan',
    '8': 'Operator mesin dan perakitan',
    '9': 'Pekerjaan dasar',
  },
  isced: {
    '5': 'Diploma',
    '6': 'Sarjana',
    '7': 'Magister',
    '8': 'Doktor',
  },
  profileCreate: {
    photoPickerFailed: "Galeri foto tidak dapat dibuka.",
    title: 'Buat profilmu',
    addPhoto: 'Tambah foto',
    name: 'Namamu',
    surname: 'Nama belakangmu',
  },
  terms: {
    title: 'Sebelum mulai',
    age: 'Saya berusia di atas 18 tahun',
    accept: 'Saya telah membaca dan menyetujui Ketentuan Layanan dan Kebijakan Privasi',
    termsLink: 'Ketentuan Layanan',
    privacyLink: 'Kebijakan Privasi',
    continue: 'Setujui dan lanjutkan',
    saveFailed: 'Persetujuanmu tidak bisa disimpan. Periksa koneksimu dan coba lagi.',
    docPlaceholder: 'Dokumen ini akan segera diterbitkan.',
  },
  locationConsent: {
    title: 'Lokasi, hanya jika kamu mengizinkan',
    body: 'Kami memerlukan izin lokasi untuk menyarankan distrik dan kota saat kamu mengambil foto.',
    privacy: 'Langkah ini tidak membaca lokasimu. Lokasi hanya digunakan setelah foto berhasil diambil; koordinat persis tidak disimpan. Izin dapat diubah nanti di pengaturan perangkat.',
    allow: 'Izinkan lokasi',
    later: 'Nanti saja',
  },
  discover: {
    title: "Jelajahi",
    categories: "Kategori pekerjaan",
    categoryHint: "Temukan orang berdasarkan pekerjaan yang dibagikan di profil mereka.",
    all: "Semua",
    reset: "Hapus filter",
    failed: 'Gagal memuat',
    free: 'Gratis',
    empty: 'Belum ada siapa-siapa di sini',
  },
  userProfile: {
    smsVerifiedOn: "Telepon diverifikasi melalui SMS · {date}",
    googleLinkedOn: "Akun Google ditautkan · {date}",
    contactProofNote: "Mengonfirmasi akses ke telepon atau akun Google, bukan identitas seseorang.",
    failed: 'Gagal memuat profil',
    sendMessage: 'Kirim pesan',
    buyTime: 'Usulkan pertemuan',
    block: 'Blokir',
    blockedNotice: '{name} diblokir. Pesan, panggilan, dan pertemuan dinonaktifkan.',
    blockTitle: 'Blokir {name}?',
    blockMessage: 'Orang ini tidak bisa mengirim pesan atau menemukanmu di halaman Jelajahi.',
    blockConfirm: 'Blokir',
  },
  callHistory: {
    empty: 'Belum ada panggilan',
    tabAll: 'Semua',
    tabMissed: 'Tak terjawab',
    emptyMissed: 'Tidak ada panggilan tak terjawab',
    failed: 'Tidak dapat memuat panggilan',
    outgoing: 'Keluar',
    incoming: 'Masuk',
    missed: 'Tak terjawab',
    declined: 'Ditolak',
    cancelled: 'Dibatalkan',
  },
  call: {
    title: 'Panggilan suara',
    calling: 'Memanggil…',
    incoming: 'Panggilan masuk',
    connecting: 'Menghubungkan…',
    connected: 'Tersambung',
    reconnecting: 'Menyambungkan ulang…',
    logAnswered: 'Panggilan suara',
    logAnsweredVideo: 'Panggilan video',
    logNoAnswer: 'Tidak dijawab',
    logMissed: 'Panggilan tak terjawab',
    logDeclined: 'Panggilan ditolak',
    logYouDeclined: 'Kamu menolak panggilan',
    logCancelled: 'Panggilan dibatalkan',
    ended: 'Panggilan berakhir',
    accept: 'Jawab',
    decline: 'Tolak',
    hangUp: 'Akhiri',
    close: 'Tutup',
    mute: 'Bisukan mikrofon',
    unmute: 'Aktifkan mikrofon',
    cameraOff: 'Matikan kamera',
    cameraOn: 'Nyalakan kamera',
    flipCamera: 'Ganti kamera',
    audioOutput: 'Keluaran audio: {route}',
    audioOutputTitle: 'Pilih keluaran audio',
    earpiece: 'Earpiece',
    speaker: 'Speaker',
    bluetooth: 'Bluetooth',
    bluetoothPermissionDenied: 'Izin Bluetooth nonaktif. Aktifkan di Pengaturan.',
    micPermission: 'Panggilan butuh akses mikrofon. Aktifkan di Pengaturan.',
    micPermissionWeb: 'Panggilan butuh akses mikrofon. Izinkan di pengaturan situs browsermu.',
    wiredHeadset: 'Headset berkabel',
    audioRouteFailed: 'Keluaran audio tidak dapat diubah',
    acceptFailed: 'Panggilan tidak dapat dijawab. Coba lagi.',
    declineFailed: 'Panggilan tidak dapat ditolak. Coba lagi.',
    endFailed: 'Panggilan tidak dapat diakhiri. Coba lagi.',
    mediaConnectionFailed: 'Koneksi audio tidak dapat dibuat. Panggilan berakhir tanpa biaya.',
    remaining: 'Sisa {time}',
    endingSoon: 'Panggilan ini akan segera berakhir.',
    spent: '{amount} terpakai',
    earned: '{amount} diperoleh',
    noAudioNotice: 'Versi ini belum mengirimkan audio. Alur panggilan dan penagihan sedang diuji.',
    failed: 'Panggilan tidak bisa dimulai',
    insufficient: 'Saldomu tidak cukup untuk panggilan ini',
    busy: 'Dia sedang dalam panggilan lain',
    notAllowed: 'Kamu bisa menelepon setelah ada setidaknya satu pesan di antara kalian',
    notAccepting: 'Orang ini sedang tidak menerima panggilan',
    priceFree: 'Gratis',
    priceChanged: 'Tarif panggilan berubah. Lihat tarif baru lalu coba lagi.',
    rateLimited: 'Kamu terlalu sering mencoba menelepon. Tunggu sebentar, lalu coba lagi.',
    reservationLinkUnavailable: 'Reservasi ini tidak dapat lagi ditautkan ke panggilan. Kamu dapat memulai panggilan biasa sebagai gantinya.',
    missed: 'Panggilan tak terjawab',
    callNow: 'Telepon sekarang',
    videoNow: 'Panggilan video sekarang',
    scheduledStartTitle: 'Panggilan terjadwal',
    scheduledStartBody: 'Panggilan terjadwal dengan {name} dimulai. Telepon sekarang?',
    schedule: 'Jadwalkan panggilan',
    scheduleTitle: 'Jadwalkan panggilan dengan {name}',
    subjectPlaceholder: 'Topik (opsional)',
    priceNote: 'Tarif panggilan: {price}',
    sendReservation: 'Kirim permintaan reservasi',
    reservationSent: 'Permintaan terkirim',
    reservationSentBody: 'Permintaan reservasi panggilanmu dikirim ke {name}.',
    reservationFailed: 'Permintaan reservasi panggilan tidak dapat dikirim',
    reservationBubble: '☎️ Reservasi panggilan diminta',
    reservationBubbleShort: '☎️ Reservasi panggilan',
    reservationLabel: 'Reservasi panggilan suara',
    rescheduleBubble: '☎️ Waktu panggilan baru diusulkan',
    rescheduleBubbleShort: '☎️ Waktu panggilan baru',
  },
  wallet: {
    otherAmount: "Lainnya",
    customAmount: "Jumlah",
    customAmountHint: "Maksimal {amount}; paling banyak dua angka desimal.",
    title: 'Dompet',
    failed: 'Gagal memuat dompet',
    availableBalance: 'Saldo tersedia',
    earningsTitle: 'Penghasilan saya',
    earningsTotal: 'Total penghasilan',
    earningsWithdrawable: 'Tersedia untuk ditarik',
    earningsEscrow: 'Dalam escrow',
    addFunds: 'Tambah saldo',
    addFundsDemo: 'Demo: tambahkan saldo uji coba ke akunmu',
    addFundsFailed: 'Gagal menambah saldo.',
    topupLabel: 'Saldo ditambahkan',
    transactions: 'Transaksi',
    noTransactions: 'Belum ada transaksi',
    waiting: 'tertunda',
    incomingRequest: 'permintaan masuk',
    replied: 'dibalas',
    earned: 'diterima',
    refunded: 'Dikembalikan',
    requestPayout: 'Tarik dana',
    payoutHint: 'Kamu bisa menarik hingga {amount}.',
    payoutAll: 'Pilih jumlah maksimum',
    payoutRequested: 'Permintaan diterima',
    payoutRequestedBody: 'Permintaan penarikan sebesar {amount} telah dibuat dan akan segera diproses.',
    payoutFailed: 'Permintaan penarikan gagal dibuat',
    payoutRequests: 'Permintaan penarikan',
    noPayouts: 'Belum ada permintaan penarikan',
    payoutStatusPending: 'Menunggu',
    payoutStatusPaid: 'Dibayar',
    payoutStatusRejected: 'Ditolak',
    paymentAccount: 'Akun pembayaran',
    stripeConnect: 'Hubungkan akun pembayaran',
    stripeConnectInfo: 'Hubungkan rekening bank untuk menerima penghasilanmu (Stripe, mode uji coba)',
    stripeConnected: 'Terhubung',
    stripeConnectFailed: 'Gagal terhubung',
  },
  calendar: {
    dateInputLabel: "Tanggal",
    timeInputLabel: "Waktu",
    dateInputHint: "Masukkan tahun, bulan, dan hari dalam format YYYY-MM-DD.",
    timeInputHint: "Masukkan waktu dalam format 24 jam: HH:MM.",

    previousWeek: 'Minggu sebelumnya',
    nextWeek: 'Minggu berikutnya',
    empty: 'Tidak ada permintaan untuk ditampilkan',
    failed: 'Kalender gagal dimuat',
    statusPending: 'Menunggu',
    statusAccepted: 'Diterima',
    statusDeclined: 'Ditolak',
    statusCancelled: 'Dibatalkan',
    statusExpired: 'Kedaluwarsa',
    accept: 'Terima',
    decline: 'Tolak',
    cancel: 'Batalkan',
    cancelConfirmationTitle: 'Batalkan reservasi ini?',
    cancelConfirmationAcceptedBody: 'Reservasi yang sudah dikonfirmasi dengan {name} akan dibatalkan. Orang tersebut akan diberi tahu dan tindakan ini tidak dapat diurungkan.',
    cancelConfirmationPendingBody: 'Usulan yang dikirim kepada {name} akan ditarik. Orang tersebut akan diberi tahu dan tindakan ini tidak dapat diurungkan.',
    actionFailed: 'Tindakan gagal',
    proposeTitle: 'Usulkan pertemuan dengan {name}',
    locationPlaceholder: 'Di mana? (opsional)',
    sendProposal: 'Kirim usulan',
    proposalSent: 'Usulan terkirim',
    proposalSentBody: 'Usulan pertemuanmu telah dikirim ke {name}.',
    priceChangedBody: 'Tarif per menit untuk reservasi ini sekarang {amount}. Tidak ada usulan yang dibuat — lihat tarif baru lalu ajukan lagi.',
    proposalFailed: 'Usulan gagal dikirim',
    meetupBubble: '📅 Pertemuan diusulkan',
    meetupBubbleShort: '📅 Usulan pertemuan',
    proposeAction: '📅 Usulkan pertemuan',
    priceNote: 'Tarif pertemuan: {price}',
    totalCost: 'Total: {amount}',
    minutesShort: 'mnt',
    tabRequests: 'Permintaan',
    tabCalendar: 'Kalender',
    tabActive: 'Saat ini',
    tabHistory: 'Riwayat',
    loadMore: 'Tampilkan lainnya',
    noEventsForDay: 'Tidak ada acara pada hari tersebut',
    meetupLabel: 'Pertemuan langsung',
    reservationDetails: 'Detail reservasi',
    reservationParticipant: 'Orang',
    reservationHeld: 'Panggilan telah dilakukan',
    reservationNotHeld: 'Tidak ada panggilan',
    reservationDateTime: 'Tanggal dan waktu',
    reservationDuration: 'Durasi',
    reservationRate: 'Per menit',
    reservationLocation: 'Lokasi',
    reservationSubject: 'Topik',
    reservationQuotedTotal: 'Total penawaran',
    reservationBilledDuration: 'Durasi ditagih',
    reservationSpentAmount: 'Jumlah dibayar',
    reservationEarnedAmount: 'Jumlah diperoleh',
    reservationSettledAt: 'Diselesaikan',
    reservationCreated: 'Dibuat',
    reservationResponded: 'Ditanggapi',
    reservationAcceptedAt: 'Diterima',
    reservationDeclinedAt: 'Ditolak',
    reservationCancelledAt: 'Dibatalkan',
    reservationCancelledBy: 'Dibatalkan oleh',
    reservationYou: 'Kamu',
    reservationCancellationNotification: 'Pengiriman notifikasi',
    reservationNotificationPending: 'Sedang disiapkan',
    reservationNotificationProviderAccepted: 'Diterima oleh penyedia pengiriman',
    reservationNotificationSuppressed: 'Tidak dikirim karena preferensi notifikasi',
    reservationNotificationUnavailable: 'Tidak ada perangkat yang memenuhi syarat',
    reservationPendingReschedule: 'Usulan waktu baru',
    reservationNewTime: 'Tanggal dan waktu baru',
    proposeNewTime: 'Usulkan waktu baru',
    rescheduleFuture: 'Waktu baru harus berada di masa depan dan berbeda setidaknya satu menit dari waktu mulai reservasi yang dijadwalkan saat ini.',
    reservationCallTooEarly: 'Panggilan terjadwal ini tersedia 15 menit sebelum dimulai.',
    reservationCallExpired: 'Jendela panggilan untuk reservasi ini telah berakhir.',
    reservationCallInProgress: 'Panggilan yang terhubung dengan reservasi ini sudah dimulai.',
    reservationExecutionLocked: 'Panggilan terjadwal ini tidak dapat diubah lagi karena sudah dimulai atau selesai.',
    openReservation: 'Buka detail reservasi dengan {name}',
    systemEventMeetupTitle: 'Pertemuan dengan {name}',
    systemEventCallTitle: 'Panggilan terjadwal dengan {name}',
    systemEventNotes: 'Disetujui melalui nosubject.',
    systemCalendarCopyRemoved: 'Salinan kalender sistem telah dihapus',
    restoreSystemCalendarCopy: 'Pulihkan',
    systemCalendarRestoreFailed: 'Salinan kalender tidak dapat dipulihkan. Periksa koneksi kalender dan izin sistem.',
    systemCalendarCopyChanged: 'Waktu kalender sistem telah diubah',
    reviewSystemCalendarChange: 'Tinjau',
    systemCalendarChangeTitle: 'Waktu kalender berubah',
    systemCalendarChangeBody: 'Perubahan ini belum diterapkan pada jadwal peserta lainnya.\n\nnosubject: {nosubject}\nKalender sistem: {system}',
    restoreNosubjectTime: 'Pulihkan waktu nosubject',
    systemCalendarTimeRestoreFailed: 'Waktu salinan kalender tidak dapat diperbaiki. Periksa koneksi kalender dan izin sistem.',
    proposeReschedule: 'Usulkan kepada peserta lainnya',
    rescheduleSent: 'Waktu baru diusulkan',
    rescheduleSentBody: 'Usulan waktu baru dikirim kepada {name}. Jadwal reservasi saat ini tetap berlaku sampai dia menyetujuinya.',
    rescheduleFailed: 'Waktu baru tidak dapat diusulkan.',
    rescheduleActionFailed: 'Usulan waktu tidak dapat diperbarui.',
    reschedulePendingReceived: 'Usulan waktu baru: {time}',
    reschedulePendingSent: 'Waktu baru menunggu jawaban: {time}',
    withdrawReschedule: 'Tarik usulan',
    rescheduleBubble: '📅 Waktu pertemuan baru diusulkan',
    rescheduleBubbleShort: '📅 Waktu pertemuan baru',
    connectionsTitle: 'Koneksi kalender',
    connectionsInfo: 'Pilih kalender yang ingin ditampilkan',
    deviceCalendar: 'Kalender perangkat',
    connect: 'Hubungkan',
    openSettings: 'Buka pengaturan',
    permissionGranted: 'Akses diberikan',
    permissionDenied: 'Akses dinonaktifkan',
    permissionUnavailable: 'Tidak tersedia pada versi ini',
    permissionNotRequested: 'Belum terhubung',
    devicePermissionInfo: 'Izin hanya diminta setelah kamu mengetuk tombol ini. nosubject hanya membaca kalender terpilih dan rentang waktu yang diperlukan; layar ini tidak menulis acara.',
    selectCalendars: 'Kalender yang ditampilkan',
    noDeviceCalendars: 'Tidak ada kalender acara yang tersedia di perangkat ini.',
    manageSystemPermission: 'Kelola izin kalender sistem',
    connectionPrivacyInfo: 'Pilihan disimpan di perangkat ini untuk akun ini. Detail acara eksternal hanya digunakan di tampilanmu dan tidak dibagikan otomatis.',
    newBuildRequired: 'Versi aplikasi yang lebih baru diperlukan untuk koneksi kalender.',
    connectionFailed: 'Kalender tidak dapat dihubungkan.',
    disconnect: 'Putuskan',
    disconnectTitle: 'Putuskan kalender?',
    disconnectBody: 'nosubject akan berhenti membaca kalender dan menulis acara baru yang disetujui di perangkat ini. Pilihan dan pemetaan lokal dihapus; acara kalender sistem yang sudah ada tetap tersedia. Izin sistem dapat dicabut secara terpisah melalui pengaturan perangkat.',
    disconnectFailed: 'Kalender tidak dapat diputuskan.',
    selectionSaveFailed: 'Pilihan kalender tidak dapat disimpan.',
    allDay: 'Sepanjang hari',
    recurring: 'Berulang',
    availabilityFree: 'Senggang',
    availabilityBusy: 'Sibuk',
    availabilityTentative: 'Belum dikonfirmasi',
    availabilityUnavailable: 'Tidak tersedia',
    untitledExternalEvent: 'Acara tanpa judul',
    externalEventsFailed: 'Acara kalender eksternal tidak dapat dimuat.',
    hideExternalEvent: 'Sembunyikan {title} dari tampilan ini',
    hideExternalEventFailed: 'Acara tidak dapat disembunyikan.',
    restoreHiddenExternalEvents: 'Tampilkan lagi acara tersembunyi',
    restoreHiddenExternalEventsFailed: 'Acara tersembunyi tidak dapat ditampilkan kembali.',
    hiddenExternalEventCount: '{count} acara disembunyikan di perangkat ini',
    checkIncompleteTitle: 'Pemeriksaan kalender belum lengkap',
    checkIncompleteBody: 'Setidaknya satu sumber kalender untuk sementara tidak dapat dibaca, sehingga kami tidak dapat memastikan bahwa waktu ini benar-benar kosong. Kamu tetap dapat melanjutkan.',
    conflictCheckIncomplete: 'Beberapa kalender tidak dapat dibaca, jadi mungkin ada bentrok lain.',
    conflictTitle: 'Bentrok kalender',
    reservationUnavailable: 'Waktu ini tidak lagi tersedia karena reservasi lain telah dikonfirmasi.',
    reservationChanged: 'Reservasi ini berubah di layar atau perangkat lain. Kami telah memuat versi terbarunya.',
    reservationPast: 'Reservasi yang waktu mulainya telah lewat tidak dapat diterima.',
    conflictBody: 'Waktu ini bertumpang tindih dengan acara lain di kalendermu. Kamu tetap dapat melanjutkan.',
    tentativeConflictTitle: 'Acara kalender belum dikonfirmasi',
    tentativeConflictBody: 'Ada acara kalender pada waktu ini yang belum dikonfirmasi. Periksa detailnya sebelum melanjutkan.',
    conflictMore: '• Acara lainnya: {count}',
    continueAnyway: 'Tetap lanjutkan',
    onlineCalendars: 'Kalender online',
    googleCalendar: 'Google Kalender',
    providerConnected: 'Terhubung',
    providerNotConnected: 'Belum terhubung',
    providerUnavailable: 'Koneksi resmi sedang dipersiapkan',
    googlePrivacyInfo: 'Hanya kalender yang kamu pilih yang disinkronkan. Judul dan lokasi dienkripsi dalam cache server minimal; deskripsi, peserta, dan tautan konferensi tidak disimpan. nosubject tidak dapat membuat, mengubah, atau menghapus acara Google Kalender.',
    googleConnectionFailed: 'Koneksi Google Kalender tidak dapat dimulai.',
    microsoftCalendar: 'Kalender Microsoft',
    microsoftInfo: 'nosubject hanya membaca ketersediaanmu (Calendars.Read). Ia tidak dapat membuat, mengubah, atau menghapus acara. Akses dicabut di pengaturan akun Microsoft-mu; nosubject tidak dapat mencabutnya sendiri.',
    microsoftConnectionFailed: 'Koneksi Kalender Microsoft tidak dapat dimulai.',
    googleDisconnectTitle: 'Putuskan Google Kalender?',
    googleDisconnectBody: 'nosubject akan berhenti mengakses data Google Kalender dan mencabut izin Google yang diberikan kepada nosubject. Acara di Google Kalender tidak akan dihapus.',
    googleDisconnectFailed: 'Google Kalender tidak dapat diputuskan.',
    googleNoCalendars: 'Tidak ditemukan Google Kalender yang dapat dibaca.',
    googleSelectionSaveFailed: 'Pilihan Google Kalender tidak dapat disimpan.',
  },
  instagram: {
    title: 'Koneksi Instagram',
    connectInfo: 'Hubungkan akun profesionalmu dengan persetujuan yang jelas',
    connectedAccounts: 'Akun terhubung',
    professionalAccount: 'Akun profesional',
    connect: 'Hubungkan',
    reconnect: 'Hubungkan ulang',
    connectedAs: '@{username} · {accountType}',
    notConnected: 'Belum terhubung',
    unavailable: 'Koneksi resmi sedang dipersiapkan',
    privacyInfo: 'Tahap pertama hanya meminta instagram_business_basic untuk membaca identitas akun profesional. Tidak ada izin pesan, komentar, atau penerbitan yang diminta, dan foto tidak disalin ke nosubject sampai kamu memilih untuk mengimpornya secara terpisah.',
    business: 'Bisnis',
    creator: 'Kreator',
    connectionFailed: 'Koneksi Instagram tidak dapat dimulai.',
  },
  inbox: {
    markUnread: 'Tandai belum dibaca',
    markRead: 'Tandai sudah dibaca',
    archiveTitle: 'Arsip',
    archive: 'Arsip',
    failed: 'Gagal memuat percakapan',
    searchEmpty: 'Tidak ada hasil',
    archivedEmpty: 'Tidak ada percakapan yang diarsipkan',
    empty: 'Belum ada percakapan',
    you: 'Kamu:',
    archived: 'Diarsipkan',
    unarchived: 'Dibatalkan dari arsip',
    undo: 'Urungkan',
    mute: 'Bisukan',
    muteTitle: 'Bisukan {name}',
    mute1h: 'Selama 1 jam',
    mute8h: 'Selama 8 jam',
    mute1w: 'Selama 1 minggu',
    muteForever: 'Sampai saya nonaktifkan',
    unmute: 'Aktifkan suara',
    archiveAction: 'Arsipkan',
    unarchiveAction: 'Keluarkan dari arsip',
    swipeRemove: 'Keluarkan dari arsip',
    swipeArchive: 'Arsipkan',
    blockAction: 'Blokir',
    blockTitle: 'Blokir {name}?',
    blockMessage: 'Orang ini tidak bisa mengirim pesan atau menemukanmu di halaman Jelajahi.',
    blockConfirm: 'Blokir',
  },
  // 9.33.9.3 / D-780 — passkeys, named as the system names them.
  passkeys: {
    // D-882 — signing in with a passkey.
    signIn: "Masuk dengan kunci sandi",
    signInIntro: "Dengan kunci sandi, kamu bisa masuk tanpa nomor telepon atau kode.",
    signInNone: "Perangkat ini tidak punya kunci sandi untuk nosubject. Masuk dulu dengan nomor teleponmu, lalu tambahkan di Profil → Pengaturan → Metode masuk → Kunci sandi.",
    signInFailed: "Tidak bisa masuk dengan kunci sandimu. Silakan coba lagi.",
    // D-876 — a lost passkey, reset after a 48-hour wait.
    lost: "Kehilangan kunci sandi?",
    recoveryIntro: "Jika tidak ada lagi perangkatmu yang menyimpan kunci sandimu, kamu bisa mengatur ulangnya. Setelah nomormu dikonfirmasi, ada waktu tunggu 48 jam. Kami akan memberitahumu di chat, dan siapa pun yang memegang kunci sandimu bisa membatalkan pengaturan ulang.",
    recoveryPending: "Pengaturan ulang siap pada {date}.",
    recoveryCancel: "Batalkan pengaturan ulang",
    recoveryCancelled: "Pengaturan ulang dibatalkan.",
    recoveryReady: "Pengaturan ulang sudah siap. Tambahkan kunci sandi barumu.",
    recoveryDone: "Kunci sandi barumu telah ditambahkan. Yang lama tidak berlaku lagi.",
    title: "Kunci sandi",
    intro: "Kunci sandi memastikan bahwa itu kamu dengan cara yang sama seperti kamu membuka kunci perangkat ini. Kunci sandi tetap di perangkatmu; nosubject tidak pernah menerima wajah atau sidik jarimu.",
    taskIntro: "Pesan yang kamu kirim ke akun resmi nosubject dikonfirmasi dengan kunci sandi sebelum dikirim.",
    empty: "Kamu belum punya kunci sandi.",
    add: "Tambahkan kunci sandi",
    remove: "Hapus",
    removeTitle: "Hapus kunci sandi ini?",
    removeBody: "Kamu akan mengonfirmasi dengan kunci sandi terlebih dahulu.",
    added: "Kunci sandi ditambahkan.",
    removed: "Kunci sandi dihapus.",
    addedOn: "Ditambahkan {date}",
    lastUsed: "Terakhir dipakai {date}",
    unnamed: "Kunci sandi",
    reauthIntro: "Untuk menambahkan kunci sandi pertamamu, konfirmasi nomor telepon terdaftarmu.",
    sendCode: "Kirim kode verifikasi",
    codeSent: "Kode telah dikirim ke nomor terdaftarmu yang berakhiran {phone}.",
    codeLabel: "Kode verifikasi",
    startAgain: "Mulai lagi",
    wrongCode: "Kode itu tidak berhasil. Kirim kode baru.",
    failed: "Permintaan tidak dapat diselesaikan. Silakan coba lagi.",
    exists: "Perangkat ini sudah punya kunci sandi untuk akunmu.",
    unsupportedApp: "Versi aplikasi ini belum bisa memakai kunci sandi. Fitur ini hadir di pembaruan aplikasi berikutnya.",
    unsupportedWeb: "Browser ini tidak bisa memakai kunci sandi.",
    tapTitle: "Lanjutkan dengan kunci sandimu",
    tapAction: "Lanjutkan",
  },
  message: {
    info: "Info pesan",
    infoSentAt: "Dikirim",
    infoReadAt: "Dibaca",
    infoPlatform: "Dikirim dari",
    // 9.33.9.4 — a message to the task chat stopped for its passkey.
    passkeyNeededTitle: "Tambahkan kunci sandi dulu",
    passkeyNeededBody: "Pesan ke akun ini dikonfirmasi dengan kunci sandi. Tambahkan satu, lalu kirim lagi.",
    passkeyUnavailable: "Pesan ini memerlukan kunci sandimu, yang belum bisa dipakai oleh versi aplikasi ini. Kirim dari nosubject.co atau setelah pembaruan berikutnya.",
    passkeyFailed: "Pesan tidak dapat dikonfirmasi, jadi tidak dikirim.",
    forwardOwn: "Teruskan",
    forwardHint: "Pilih percakapan. Teks dibuka sebagai draf; pengiriman dan konfirmasi harga saat ini tetap terpisah.",
    forwardEmpty: "Tidak ada percakapan aktif lainnya.",
    forwardDraftFirst: "Kirim atau hapus draf saat ini terlebih dahulu.",
    translationLanguage: "Bahasa terjemahan",
    chooseTranslationLanguage: "Pilih bahasa terjemahan",
    languageSuggestion: "Saran bahasa perangkat",
    translationLanguageInfo: "Preferensi pribadi ini berlaku untuk terjemahan di semua percakapanmu. Tidak ditambahkan ke profilmu.",
    photoCaption: "Tambahkan keterangan foto…",
    removePhoto: "Hapus foto",
    star: "Beri bintang",
    unstar: "Hapus bintang",
    starred: "Pesan berbintang",
    noStars: "Tidak ada pesan berbintang dalam percakapan ini.",
    starFailed: "Bintang tidak dapat diperbarui. Coba lagi.",
    starredAttachment: "Pesan dengan lampiran",
    edit: "Edit pesan",
    edited: "Diedit",
    editInfo: "Pesan dapat diedit sampai dibaca, meski tanda baca dinonaktifkan. Hilangnya opsi Edit bisa mengungkap bahwa pesan dibaca. Belum dibaca bukan berarti belum dilihat: teks awal mungkin terlihat di pratinjau notifikasi. Mengedit tidak menjamin ucapan dapat ditarik kembali.",
    editFailed: "Edit belum dapat dikonfirmasi. Pesan mungkin sudah dibaca atau diubah. Periksa percakapan sebelum mencoba lagi.",
    copy: "Salin",
    copyFailed: "Pesan tidak dapat disalin. Coba lagi.",
    inputPlaceholder: 'Tulis pesan…',
    typing: 'Sedang mengetik',
    translate: 'Terjemahkan',
    withdrawn: 'Pesan ditarik',
    linkOpenTitle: 'Buka tautan',
    linkOpenBody: 'Ini membawamu ke {host}. Tautan dikirim oleh orang yang mengirimimu pesan — hati-hati kalau kamu tidak mengenalnya.',
    linkOpenConfirm: 'Buka',
    linkOpenFailed: 'Tautan tidak bisa dibuka.',
    seenAt: 'Dilihat {time}',

    priceChangedTitle: 'Harga berubah',
    priceChangedBody: 'Pesan ini kini {new}, bukan {old}. Tetap kirim?',
    priceChangedSend: 'Kirim',
    priceNoticeTitle: 'Biaya bicara dengan orang ini',
    priceNoticeMessage: '{amount} per pesan',
    priceNoticeCall: 'Panggilan {amount}',
    priceNoticePersonal: 'Tarif ini ditetapkan khusus untukmu.',
    priceDecreasedTitle: "Harga pesan turun",
    priceDecreasedBody: "Pesan kini dikenai biaya {new}, bukan {old}. Harga yang lebih rendah tidak memerlukan persetujuan.",
    priceChange: {
      free: 'gratis',
    },
    expired: 'kedaluwarsa, dikembalikan',
    // 9.2 / D-650 — web'den gönderilen mesajın saat satırındaki notu.
    sentFromWeb: 'lewat web',
    linkViewLabel: 'Tampilan tautan',
    linkViewPlain: 'Alamat biasa',
    linkViewCompact: 'Ringkas',
    linkViewCard: 'Kartu besar',
    linkPreviewLoading: 'Menyiapkan pratinjau…',
    linkPreviewFailed: 'Pratinjau untuk tautan ini tidak bisa dibuat; tautan akan dikirim sebagai alamat biasa.',
    linkPreviewA11y: 'Tautan: {title}, {host}',
    customPrice: 'Harga khusus',
    priceUsesGeneral: 'Harga umum saya berlaku',
    priceRemove: 'Keluarkan dari kontak',
    priceRemoveTitle: 'Keluarkan {name} dari kontakmu?',
    priceRemoveBody: 'Harga khusus dihapus dan {name} kembali ke harga umummu. Kalau hanya kontak yang boleh mengirim pesan, dia tidak bisa lagi memulai percakapan baru. Ini bukan pemblokiran.',
    priceRemoveConfirm: 'Keluarkan',
    priceRemoved: '{name} kembali ke harga umummu.',
    pricePrompt: 'Harga untuk {name} (0 = gratis):',
    saved: 'Tersimpan',
    priceFreeSet: '{name} sekarang bisa mengirimimu pesan gratis.',
    priceSet: 'Harga untuk {name} diatur menjadi {price}.',
    saveError: 'Gagal menyimpan.',
    photoError: 'Gagal mengirim foto.',
    noConnection: 'Tidak ada koneksi',
    checkInternet: 'Periksa koneksi internetmu.',
    sendError: 'Gagal mengirim pesan.',
    addAttachment: 'Tambahkan lampiran',
    sendMessageAction: 'Kirim pesan',
    lowBalanceTitle: 'Saldo tidak cukup',
    lowBalanceBody: 'Saldomu di bawah harga pesan orang ini. Tambahkan saldo dan coba lagi.',
    reply: 'Balas',
    reactionA11y: 'Reaksi {emoji}, total {count}',
    reactionA11yMine: 'Reaksi {emoji}, total {count}, termasuk milikmu',
    reactionAdd: 'Bereaksi dengan {emoji}',
    moreReactions: 'Emoji lainnya',
    reactionRemove: 'Hapus reaksi {emoji} milikmu',
    you: 'Kamu',
    photo: '📷 Foto',
    takePhoto: 'Ambil foto',
    choosePhoto: 'Pilih dari galeri',
    chooseVideo: 'Pilih video',
    recordVoice: 'Pesan suara',
    micPermissionTitle: 'Perlu akses mikrofon',
    micPermissionBody: 'Merekam pesan suara memerlukan akses mikrofon.',
    voiceError: 'Pesan suara tidak dapat dikirim',
    voiceRecording: 'Merekam',
    videoTooLarge: 'Video terlalu besar (maksimal 1 GB)',
    videoTooLong: 'Video terlalu panjang (maksimal 10 menit)',
    videoError: 'Video tidak dapat dikirim',
    videoNeedsUpdate: 'Perbarui aplikasi untuk menonton video ini',
    voiceNeedsUpdate: 'Perbarui aplikasi untuk memutar pesan suara ini',
    voiceOrderTitle: 'Pesan suara dipesan',
    encrypted: 'Pesan terenkripsi',
    identityChanged: 'Kunci keamanan orang ini berubah. Biasanya berarti ponsel baru atau aplikasi yang dipasang ulang.',
    identityChangedVerify: 'Kamu sudah memverifikasi chat ini; cocokkan lagi nomor keamanannya.',
    unencrypted: 'Obrolan ini tidak terenkripsi',
    unencryptedPeerInfo: 'Aplikasi orang lain itu belum mendukung enkripsi ujung ke ujung, jadi yang kamu tulis di sini terkirim tanpa enkripsi dan bisa dibaca di server nosubject. Setelah dia memperbarui aplikasinya, pesan baru akan terenkripsi otomatis.',
    unencryptedOfficialInfo: 'Ini akun resmi nosubject. Yang kamu tulis di sini terkirim tanpa enkripsi dan bisa dibaca oleh tim nosubject.',
    unencryptedSelfInfo: 'Enkripsi tidak bisa diaktifkan di perangkat ini (misalnya, jendela pribadi browser tidak bisa menyimpan kunci). Yang kamu kirim dari sini tidak terenkripsi dan bisa dibaca di server nosubject.',
    notificationOfferEnable: 'Nyalakan notifikasi',
    notificationOfferEnabled: 'Notifikasi menyala',
    voiceOrderPending: 'Menunggu pengiriman',
    voiceOrderDelivered: 'Terkirim',
    voiceOrderDeclined: 'Ditolak, dikembalikan',
    voiceOrderExpired: 'Kedaluwarsa, dikembalikan',
    voiceOrderAction: 'Pesan pesan suara',
    voiceOrderPick: 'Berapa lama rekamannya?',
    voiceOrderInsufficient: 'Saldomu tidak cukup untuk pesanan ini.',
    voiceOrderError: 'Pesanan tidak bisa dibuat.',
    voiceOrderRecord: 'Rekam dan kirim',
    voiceOrderDecline: 'Tolak',
    voiceOrderDeclineTitle: 'Tolak pesanan',
    voiceOrderDeclineBody: 'Seluruh dana yang ditahan kembali ke orang yang memesan.',
    voiceOrderDeclineError: 'Pesanan tidak bisa ditolak.',
    voiceOrderDeliverError: 'Rekaman tidak bisa dikirim.',
    voiceOrderRecording: 'Rekaman pesanan',
    voiceOrderRemaining: 'Sisa {length}',
    voiceOrderShortNote: 'Kirim lebih pendek, yang dibayar hanya yang kamu rekam.',
    voiceOrderRefunded: '{amount} dikembalikan',
    sendLocation: 'Kirim lokasi',
    locationTitle: 'Lokasi',
    locationError: 'Lokasi tidak dapat dikirim',
    shareLiveLocation: 'Bagikan lokasi langsung',
    liveLocationHour: '1 jam',
    liveLocationEightHours: '8 jam',
    liveLocationOpenEnded: 'Sampai aku hentikan',
    liveLocationSharing: 'Lokasi langsungmu sedang dibagikan',
    liveLocationStop: 'Hentikan',
    liveLocationError: 'Lokasi langsung tidak dapat dimulai',
    liveLocationCardTitle: 'Lokasi langsung',
    liveLocationCardActive: 'Sedang dibagikan',
    liveLocationCardEnded: 'Berbagi selesai',
    liveLocationOpen: 'Lihat lokasi',
    liveLocationNoPoint: 'Belum ada posisi',
    liveLocationOpenInMaps: 'Buka di Maps',
    locationMapError: 'Peta tidak dapat dibuka.',
    liveLocationUpdatedAgo: 'Diperbarui {ago}',
    videoShort: '🎬 Video',
    voiceShort: '🎙 Pesan suara',
    liveLocationWatchedAgo: 'Dilihat {ago} lalu',
    liveLocationNotWatched: 'Belum dilihat',
    liveLocationSharerSeesYou: 'Dia bisa melihat kapan kamu melihat',
    cameraPermissionTitle: 'Akses kamera diperlukan',
    cameraPermissionBody: 'Izinkan akses kamera untuk mengambil foto.',
    cameraError: 'Kamera tidak dapat dibuka.',
    photoLocationTitle: 'Lokasi foto',
    photoLocationPromptFile: '{place} dibaca dari berkas foto. Tampilkan lokasi ini bersama foto?',
    photoLocationPromptCapture: 'Lokasi perangkat menunjukkan {place}. Tampilkan lokasi ini bersama foto?',
    photoLocationHide: 'Kirim tanpa lokasi',
    photoLocationShare: 'Kirim dengan lokasi',
    photoLocationFromFile: 'Dibaca dari berkas',
    photoLocationFromCapture: 'Lokasi perangkat',
    photoLocationHideAfter: 'Sembunyikan lokasi',
    photoLocationShowAfter: 'Tampilkan lokasi',
    photoLocationUpdateError: 'Lokasi foto tidak dapat diperbarui.',
  },
  versionNotice: {
    title: 'Ada versi baru',
    body: 'Perbarui aplikasi untuk peningkatan keamanan dan fitur baru.',
    update: 'Perbarui',
  },
  notifications: {
    title: 'Notifikasi',
    cardBody: 'Aktifkan notifikasi perangkat agar tidak melewatkan pesan dan balasan baru.',
    notNow: 'Nanti saja',
    enable: 'Aktifkan notifikasi',
    device: 'Notifikasi perangkat',
    stateOn: 'Aktif · Kelola di pengaturan sistem',
    stateOff: 'Nonaktif · Aktifkan di pengaturan sistem',
    stateAsk: 'Belum pernah diminta',
    preferences: 'Preferensi notifikasi',
    preferencesInfo: 'Kelola kategori, pratinjau, dan izin perangkat',
    stateUnsupported: 'Tidak didukung di perangkat ini',
    master: 'Semua notifikasi',
    masterInfo: 'Jika dinonaktifkan, semua notifikasi push berhenti tanpa menghapus pilihan kategori',
    categories: 'Kategori',
    categoryEnabled: 'Notifikasi kategori ini',
    categoryEnabledInfo: 'Jika dinonaktifkan, notifikasi push kategori ini berhenti tanpa menghapus pilihannya',
    events: 'Peristiwa',
    messages: 'Pesan',
    messagesInfo: 'Pesan baru dan balasan',
    meetups: 'Pertemuan',
    meetupsInfo: 'Usulan, perubahan, dan hasil',
    meetupRequests: 'Usulan pertemuan baru',
    meetupRequestsInfo: 'Saat seseorang mengirim usulan pertemuan baru',
    meetupUpdates: 'Tanggapan dan pembatalan',
    meetupUpdatesInfo: 'Saat pertemuan diterima, ditolak, atau dibatalkan',
    meetupReminders: 'Pengingat pertemuan',
    meetupRemindersInfo: 'Saat pertemuan yang diterima semakin dekat',
    calls: 'Panggilan',
    callsInfo: 'Panggilan masuk, terjadwal, dan tak terjawab',
    incomingCalls: 'Panggilan masuk',
    incomingCallsInfo: 'Peringatan suara saat seseorang meneleponmu',
    callRequests: 'Usulan panggilan terjadwal',
    callRequestsInfo: 'Saat usulan dibuat, diterima, ditolak, atau dibatalkan',
    callReminders: 'Pengingat panggilan terjadwal',
    callRemindersInfo: 'Saat waktu panggilan terjadwal yang disetujui semakin dekat',
    missedCalls: 'Panggilan tak terjawab',
    missedCallsInfo: 'Saat kamu tidak dapat menjawab panggilan',
    financial: 'Uang dan escrow',
    financialInfo: 'Perubahan status transaksi',
    financialEarnings: 'Penghasilan dan escrow',
    financialEarningsInfo: 'Saat escrow dilepas atau penghasilan tersedia',
    financialRefunds: 'Pengembalian dan kedaluwarsa',
    financialRefundsInfo: 'Saat pembayaran dikembalikan atau escrow kedaluwarsa',
    financialPayouts: 'Hasil penarikan',
    financialPayoutsInfo: 'Saat permintaan penarikan berhasil atau gagal',
    reactions: 'Reaksi emoji',
    reactionsInfo: 'Reaksi pada pesanmu',
    official: 'Dari Nosubject',
    officialInfo: 'Pengumuman Nosubject tentang versi, keamanan, dan akunmu. Terpisah dari notifikasi lainnya; jika dimatikan, Nosubject tidak mengirim notifikasi, tetapi pesannya tetap masuk ke kotak masukmu.',
    preview: 'Pratinjau pesan',
    previewHidden: 'Disembunyikan',
    previewHiddenInfo: 'Jangan tampilkan pengirim atau pesan',
    previewSender: 'Hanya pengirim',
    previewSenderInfo: 'Tampilkan pengirim, sembunyikan pesan',
    previewText: 'Pengirim dan pesan',
    previewTextInfo: 'Tampilkan hingga 80 karakter',
    deviceInfo: 'Izin sistem hanya berlaku untuk perangkat ini',
    openSettings: 'Buka pengaturan',
    centerTitle: 'Pusat Notifikasi',
    centerMarkAll: 'Tandai semua dibaca', centerMarkedAll: 'Semua ditandai dibaca',
    centerEmpty: 'Belum ada notifikasi.',
    centerFailed: 'Notifikasi tidak dapat dimuat.',
    centerMarkAllFailed: 'Notifikasi tidak dapat ditandai sudah dibaca.',
    centerUnknownPerson: 'Seseorang',
    centerEscrowExpiredRefunded: 'Escrow berakhir · pembayaran dikembalikan',
    centerEscrowReleasedEarning: 'Balasan selesai · penghasilan ditambahkan',
    centerMeetupRequest: '{name} mengirim usulan pertemuan',
    centerCallRequest: '{name} mengirim usulan panggilan terjadwal',
    centerCallReminder: 'Panggilan terjadwal dengan {name} sebentar lagi',
    centerCallStarting: 'Panggilan terjadwal dengan {name} dimulai',
    centerMeetupStarting: 'Pertemuan dengan {name} dimulai',
    centerMeetupReminder: 'Pertemuan dengan {name} sebentar lagi',
    centerMeetupUpdate: '{name} · Pertemuan: {status}',
    centerCallUpdate: '{name} · Panggilan terjadwal: {status}',
    centerMeetupRescheduleRequest: '{name} mengusulkan waktu pertemuan baru',
    centerCallRescheduleRequest: '{name} mengusulkan waktu panggilan baru',
    centerMeetupRescheduleUpdate: '{name} · Waktu pertemuan baru: {status}',
    centerCallRescheduleUpdate: '{name} · Waktu panggilan baru: {status}',
    centerBell: 'Pusat Notifikasi',
    centerBellUnread: 'Pusat Notifikasi, belum dibaca: {count}',
  },
  profile: {
    viewPhoto: "Lihat foto profil",
    photoUnavailable: "Foto ini tidak dapat dimuat.",
    // 9.35.3 · D-830 — profile photos and videos.
    photos: "Foto",
    mediaPhotoLabel: "Foto {n} dari {total}",
    mediaVideoLabel: "Video {n} dari {total}",
    mediaUnavailable: "Foto tidak dapat dimuat",
    mediaMore: "Tampilkan lainnya",
    // 9.35.4 · D-830 — removing one's own photo or video.
    mediaRemove: "Hapus dari profil",
    mediaRemovePhotoTitle: "Hapus foto ini dari profilmu?",
    mediaRemoveVideoTitle: "Hapus video ini dari profilmu?",
    mediaRemoveBody: "File akan dihapus dan tidak bisa dikembalikan.",
    mediaRemoveFailed: "Gagal menghapus. Coba lagi.",
    webVisibility: 'Siapa yang bisa melihat halaman webku',
    webVisibilityLink: 'Yang punya tautan',
    webVisibilityInfo: 'Profilmu seperti yang dilihat orang tanpa akun: halamanmu di nosubject.co/nama-penggunamu. Semua orang: halamanmu juga bisa muncul di mesin pencari. Yang punya tautan: siapa pun yang tahu alamatnya bisa membukanya; mesin pencari tidak mencantumkannya. Pada keduanya, orang tanpa akun bisa mengakses info profilmu, termasuk kapan terakhir kamu online. Tidak ada: tidak ada orang tanpa akun yang bisa melihat profilmu; halaman menampilkan “Profil ini tidak tersedia”. Profilmu di aplikasi tidak berubah. Keluar dari hasil pencarian bisa memakan waktu beberapa hari.',
    linkViewInfo: 'Pilih bagaimana tautan yang kamu ketik dikirim. Untuk Ringkas dan Kartu besar, ponselmu membuka halamannya sekali dan mengirim pratinjau bersama pesan; situs itu melihat alamat IP ponselmu. Di obrolan terenkripsi, pratinjau ada di dalam enkripsi; di obrolan tanpa enkripsi, nosubject melihat tautan dan pratinjaunya. Alamat biasa tidak membuka halaman apa pun. Tautan yang dikirim dari web selalu terkirim sebagai alamat biasa.',
    linkViewAsk: 'Tampilkan pilihan saat mengetik',
    linkViewAskInfo: 'Jika aktif, dua tampilan lainnya muncul saat kamu mengetik tautan, dan kamu bisa memilih satu untuk pesan itu. Jika nonaktif, tautan selalu terkirim dengan tampilan yang kamu pilih di sini.',
    whoCanCallInfo: 'Pilih siapa yang boleh meneleponmu; berlaku untuk setiap panggilan. Kontak saya adalah orang yang kamu beri harga pribadi. Lewat Pengecualian kamu bisa mengizinkan atau memblokir orang satu per satu.',
    whoCanMessageInfo: 'Pilih siapa yang boleh memulai percakapan baru denganmu; percakapan yang sudah berjalan tidak berubah. Kontak saya adalah orang yang kamu beri harga pribadi. Lewat Pengecualian kamu bisa mengizinkan atau memblokir orang satu per satu.',
    readReceiptsInfo: "Tanda dibaca terlihat hanya jika kedua pihak mengaktifkannya. Meski nonaktif, hilangnya opsi Edit bisa mengungkap pesan sudah dibaca.",
    showTypingInfo: 'Jika aktif, orang yang sedang kamu kirimi pesan bisa melihat bahwa kamu sedang mengetik. Jika dimatikan, tidak ada yang melihatnya, dan kamu tetap bisa melihat saat orang lain mengetik.',
    officialAccount: 'Akun resmi',
    information: 'Informasi profil',
    logout: 'Keluar',
    account: 'Akun',
    accountData: 'Akun & data',
    name: 'Nama',
    surname: 'Nama belakang',
    username: 'Nama pengguna',
    usernamePlaceholder: 'namapengguna',
    usernameChecking: 'Memeriksa…',
    usernameAvailable: 'Tersedia',
    usernameTaken: 'Nama pengguna ini sudah dipakai',
    usernameInvalid: '3–20 karakter; diawali A–Z atau a–z. Hanya A–Z, a–z, 0–9, dan _ yang diizinkan.',
    usernameAdd: 'Tambahkan nama pengguna',
    profession: 'Profesi',
    professionNone: 'Belum ada profesi ditambahkan',
    professionAdd: 'Tambah profesi',
    employer: 'Perusahaan',
    employerPlaceholder: 'namapenggunaperusahaan',
    employerInfo: 'Masukkan nama pengguna nosubject yang sudah ada. Penyebutan ini tidak berarti tempat kerja telah diverifikasi.',
    employerNotFound: 'Tidak ada akun aktif dengan nama pengguna tersebut.',
    employerSelf: 'Kamu tidak dapat mencantumkan akunmu sendiri sebagai perusahaan.',
    bio: 'Ceritakan tentang dirimu…',
    prices: 'Harga',
    settings: 'Pengaturan',
    priceMessage: 'Pesan',
    priceVoice: 'Pesan suara (per menit)',
    priceVoiceShort: 'Pesan suara',
    priceCall: 'Telepon sekarang (per menit)',
    priceCallShort: 'Telepon sekarang',
    priceScheduledCall: 'Jadwalkan panggilan (per menit)',
    priceScheduledCallShort: 'Jadwalkan panggilan',
    priceVideoCall: 'Panggilan video',
    priceVideoCallShort: 'Video',
    priceTime: 'Pertemuan (per menit)',
    priceTimeShort: 'Pertemuan',
    currency: 'Mata uang',
    saving: 'Menyimpan…',
    wallet: 'Dompet',
    chatBackup: 'Cadangan obrolan',
    privacy: 'Privasi',
    readReceipts: 'Tanda sudah dibaca',
    showTyping: 'Indikator mengetik',
    keepArchived: 'Tetap diarsipkan',
    keepArchivedInfo: 'Jika nonaktif, pesan baru akan membatalkan arsip percakapan',
    whoCanMessage: 'Siapa yang bisa mengirimiku pesan',
    whoCanCall: 'Siapa yang bisa meneleponku',
    messagesFromContact: 'Pesan dari orang ini',
    callsFromContact: 'Panggilan dari orang ini',
    callExceptions: 'Pengecualian',
    callExceptionsEmpty: 'Belum ada pengecualian',
    messageExceptionsEmpty: 'Belum ada pengecualian pesan',
    exceptionsLoadFailed: 'Pengecualian tidak dapat dimuat',
    openProfileHint: 'Membuka profil orang ini',
    callExceptionBlocked: 'Diblokir',
    callsFromContactDefault: 'Default',
    callsFromContactAllow: 'Selalu izinkan',
    callsFromContactBlock: 'Tidak pernah',
    everyone: 'Semua orang',
    contacts: 'Kontak saya',
    nobody: 'Tidak ada',
    blockedUsers: 'Pengguna yang diblokir',
    blockedEmpty: 'Kamu belum memblokir siapa pun',
    unblock: 'Batalkan blokir',
    appearance: 'Tampilan',
    light: 'Terang',
    dark: 'Gelap',
    system: 'Sistem',
    displayLanguage: 'Bahasa aplikasi',
    education: 'Universitas',
    educationAdd: 'Tambah universitas',
    educationNone: 'Belum ada universitas ditambahkan',
    educationLevel: 'Jenjang',
    searchLanguage: 'Cari bahasa…',
    photoChange: 'Ubah',
    saveFailed: 'Gagal menyimpan.',
    photoFailed: 'Gagal mengunggah foto.',
    photoChanged: "Foto berubah dalam operasi lain atau batas waktu untuk mencoba lagi telah berakhir. Silakan pilih foto lagi.",
    deleteAccount: 'Hapus akun',
    deleteTitle: 'Hapus akunmu',
    deleteMessage: 'Akunmu akan dihapus permanen setelah 30 hari. Kamu bisa masuk kembali selama periode ini untuk membatalkannya.',
    deleteMoneyWarning: 'Kamu memiliki {amount} di dompet dan escrow-mu. Sebaiknya tarik dulu sebelum menghapus.',
    deleteConfirm: 'Hapus',
    deleteFailed: 'Gagal menghapus akun.',
    deletionScheduled: 'Akunmu akan dihapus pada {date}.',
    deletionCancel: 'Batalkan penghapusan akun',
    exportData: 'Unduh data saya',
    exportFailed: 'Gagal mengambil data.',
  },
  // Alt bar (dock) — ekran okuyucu etiketleri ve rozet sayıları (9.26.7.2.1)
  dock: {
    calls: 'Panggilan',
    discover: 'Jelajahi',
    inbox: 'Pesan',
    calendar: 'Kalender',
    profile: 'Profil',
    unreadMessages: '{count} belum dibaca',
    pendingRequests: '{count} menunggu',
  },
  // 9.18.10.4 · D-830 — importing one's own Instagram download.
  instagramImport: {
    title: "Impor dari Instagram",
    addEntry: "Impor dari Instagram",
    guideIntro: "Unduh data Instagram milikmu sendiri lalu pilih di sini untuk menambahkan foto dan videomu ke profil.",
    guideStep1: "Di Instagram, buka Pusat Akun → Informasi dan izin kamu → Unduh informasimu.",
    guideStep2: "Di “Sebagian informasimu”, pilih Konten saja; format JSON, kualitas media Tinggi.",
    guideStep3: "Setelah Meta menyiapkan filenya, unduh lalu pilih di sini.",
    guideOwnOnly: "Hanya foto dan video yang kamu posting yang ditampilkan; media dari pesan tidak pernah diambil.",
    guideOnDevice: "File dibuka di perangkatmu dan tidak dikirim ke server kami; hanya yang kamu pilih yang diunggah.",
    choose: "Pilih file ZIP",
    reading: "Membaca arsip",
    notZip: "File ini bukan arsip ZIP.",
    untrusted: "Arsip ini tidak terlihat aman, jadi tidak dibuka.",
    tooBig: "Arsip ini terlalu besar.",
    unreadable: "Arsip ini tidak dapat dibaca.",
    chooseAnother: "Pilih file lain",
    noMedia: "Tidak ada foto atau video yang bisa ditambahkan di arsip ini.",
    found: "{count} foto dan video ditemukan",
    slotsLeft: "Tersisa {count} tempat di profilmu",
    selectAll: "Pilih semua",
    selectNone: "Hapus pilihan",
    alreadyOnProfile: "Di profil",
    tooLarge: "Terlalu besar",
    add: "Tambahkan {count}",
    adding: "Menambahkan {n} dari {total}",
    stop: "Berhenti",
    stopping: "Berhenti setelah yang ini",
    doneAdded: "{count} ditambahkan",
    doneDuplicate: "{count} sudah ada di profilmu",
    doneSkipped: "{count} dilewati",
    doneFailed: "{count} gagal ditambahkan",
    retryFailed: "Coba sisanya lagi",
    profileFull: "Profilmu sudah penuh; tidak bisa menambah lagi.",
    guideParts: "Jika Meta membagi unduhanmu menjadi beberapa bagian ZIP, pilih semuanya sekaligus.",
    catAll: "Semua",
    catPosts: "Postingan",
    catReels: "Reels",
    catStories: "Cerita",
    catIgtv: "IGTV",
    catArchived: "Diarsipkan",
    catProfile: "Foto profil",
    catOther: "Lainnya",
    archiveSection: "Unduhan Instagram",
    archiveHint: "Menambahkan foto dan video dari unduhan datamu sendiri ke profilmu.",
  },
};
